
(function () {
    if (document.querySelectorAll(".js-office-page").length > 0) {
        let map = null;
        const officePage = {
            store: {
                zoomLevel: null,
                latitude: null,
                longitude: null,
            },
            init: () => {
                officePage.setMapDefaults();
                officePage.renderMap();
                officePage.toggleOfficeHours();
            },
            parseCoordinates: (cord) => {
                let coordinate = cord;

                if (coordinate.includes(",")) {
                    coordinate = coordinate.replace(",", ".");
                }

                return coordinate;
            },
            setMapDefaults: () => {
                const zoomLevel = document.getElementById("ZoomLevel").value;
                const latitude = document.getElementById("Latitude").value;
                const longitude = document.getElementById("Longitude").value;

                if (zoomLevel != 0) {
                    officePage.store.zoomLevel = parseInt(zoomLevel);
                }

                if (latitude !== null || undefined) {
                    officePage.store.latitude = Number(officePage.parseCoordinates(latitude));
                }

                if (longitude !== null || undefined) {
                    officePage.store.longitude = Number(officePage.parseCoordinates(longitude));
                }
            },
            renderMap: () => {
                const mapContainer = document.getElementById("map");
                // const mapLoader = document.getElementById("map__loader");

                if (mapContainer) {
                    async function initMap() {
                        const { Map } = await google.maps.importLibrary("maps");
                        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

                        map = new Map(document.getElementById("map"), {
                            zoom: officePage.store.zoomLevel,
                            center: { lat: officePage.store.latitude, lng: officePage.store.longitude },
                            mapId: '99be96ce516de3af'
                        });

                        new AdvancedMarkerElement({
                             map,
                             position: { lat: officePage.store.latitude, lng: officePage.store.longitude }
                        });

                        //google.maps.event.addListenerOnce(map, 'idle', function () {
                        //    mapLoader.classList.remove("map__loader--loading");
                        //});
                    }

                    initMap();
                }
            },
            setMapPins: (offices) => {
                const officeHits = offices;

                const intersectionObserver = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (entry.isIntersecting) {
                            entry.target.classList.add("drop");
                            intersectionObserver.unobserve(entry.target);
                        }
                    }
                });
                async function renderPins(/*officeHits*/) {
                    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

                     new AdvancedMarkerElement({
                         map,
                         position: { lat: officeHits[i].latitude, lng: officeHits[i].longitude },
                         title: officeHits[i].officeTitle
                     });

                    //let bounds = new google.maps.LatLngBounds();

                    //for (i = 0; i < officeHits.length; i++) {
                    //    let marker = new AdvancedMarkerElement({
                    //        map,
                    //        position: { lat: officeHits[i].latitude, lng: officeHits[i].longitude },
                    //        title: officeHits[i].officeTitle
                    //    });

                    //    //Adds animations to markers
                    //    let content = marker.content;

                    //    content.style.opacity = "0";

                    //    content.addEventListener("animationend", (event) => {
                    //        content.classList.remove("drop");
                    //        content.style.opacity = "1";
                    //    });

                    //   /* bounds.extend({ lat: officeHits[i].latitude, lng: officeHits[i].longitude });*/

                    //    const time = 0.2 + Math.random();

                    //    content.style.setProperty("--delay-time", time + "s");
                    //    intersectionObserver.observe(content);

                    //    let string = "<div class='info-window-title'>" + officeHits[i].officeTitle + "</div><div class='info-window-details'>" + officeHits[i].officeAdress + "</div>";

                    //    //Set marker information
                    //    let infoWindow = new google.maps.InfoWindow();

                    //    google.maps.event.addListener(marker, 'click', function () {
                    //        infoWindow.close();
                    //        infoWindow.setContent(string);
                    //        infoWindow.open(marker.map, marker);
                    //    });
                    //}

                    ////Fit map to marker bounds
                    //map.fitBounds(bounds);

                    ////Listen to bound change and set the max zoom level
                    //google.maps.event.addListenerOnce(map, "bounds_changed", function () {
                    //    this.setZoom(Math.min(this.getZoom(), 15));
                    //});
                }

                renderPins(officeHits);
            },
            toggleOfficeHours: () => {
                const toggleButton = document.querySelector("#toggle-hours");

                if (toggleButton) {
                    toggleButton.addEventListener("click", (e) => {
                        const hoursExpanded = e.currentTarget.parentNode.nextElementSibling;
                        const arrowIcon = e.currentTarget.querySelector(".icon__chevron");
                        const isExpanded = hoursExpanded.classList.contains("active");
                        
                        hoursExpanded.classList.toggle("active");
                        arrowIcon.classList.toggle("active");
                        
                        // Update aria-expanded for accessibility
                        e.currentTarget.setAttribute("aria-expanded", !isExpanded);
                    });
                }
            }

    
        };

        officePage.init();
    }
})();
